import {GET_COUNTRYGUIDES, GET_COUNTRYGUIDESDETAIL} from './endpoints';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CountryGuideService extends BaseService {

    constructor(http: HttpClient) {
        super(http);
    }

    getCountryGuides(countryGuidesParams: any): Observable<any> {
        const url = GET_COUNTRYGUIDES + this.makeQueryString(countryGuidesParams);
        return this.getRequest(url, null);
    }
    getCountryGuidesDetail(countriesParams: any, regionParams: any): Observable<any> {
        const url = GET_COUNTRYGUIDESDETAIL + countriesParams + '?regionid=' + regionParams;
        return this.getRequest(url, null);
    }
    getCountryGuide(countriesParams: any): Observable<any> {
        const url = GET_COUNTRYGUIDESDETAIL + countriesParams.id + '?regionid=' + countriesParams.regionid ;
        return this.getRequest(url, null);
    }
}
